import { render, staticRenderFns } from "./werlotus_detail.html?vue&type=template&id=b6d57a4c&scoped=true&"
import script from "./werlotus_detail.vue?vue&type=script&lang=js&"
export * from "./werlotus_detail.vue?vue&type=script&lang=js&"
import style0 from "./werlotus_detail.scss?vue&type=style&index=0&id=b6d57a4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d57a4c",
  null
  
)

export default component.exports